import { Route, Routes } from 'react-router-dom'
import About from './About'
import Hero from './Hero'
import Skills from './Skills'
import Services from './Services'
import Contact from './Contact'
import Portfolio from './Portfolio'
import Experience from './Experience'

export default function index() {
    return (
        <div style={{ minHeight: '100%', display: 'flex', flexDirection: 'column' }}>
            <Routes>
                <Route path='/' element={<Hero />} />
                <Route path='about' element={<About />} />
                <Route path='skills' element={<Skills />} />
                {/* <Route path='services' element={<Services />} /> */}
                <Route path='experience' element={<Experience />} />
                <Route path='portfolio' element={<Portfolio />} />
                <Route path='contact' element={<Contact />} />
            </Routes>
        </div>
    )
}
